import { BigNumber } from 'bignumber.js';
import { Cmp } from '@blade/std-lib';
export const unrealized = ({ remainingSize, entryPrice, currentPrice, }) => {
    return calculate({
        size: remainingSize,
        entryPrice,
        currentPrice,
    });
};
export const realized = ({ soldSize, soldValue, entryPrice, }) => {
    const soldPrice = soldValue.dividedBy(soldSize);
    return calculate({
        size: soldSize,
        entryPrice: entryPrice,
        currentPrice: soldPrice,
    });
};
export const calculate = ({ size, entryPrice, currentPrice, }) => {
    const currentValue = size.multipliedBy(currentPrice);
    const entryCost = size.multipliedBy(entryPrice);
    const pnlAbsolute = currentValue.minus(entryCost);
    const pnlPercentage = entryCost.isZero()
        ? BigNumber(0)
        : pnlAbsolute.dividedBy(entryCost).multipliedBy(100);
    return {
        pnlAbsolute,
        pnlPercentage,
    };
};
export const total = ({ soldSize, soldValue, remainingSize, entryPrice, currentPrice, }) => {
    const soldCost = soldSize.multipliedBy(entryPrice);
    const remainingCost = remainingSize.multipliedBy(entryPrice);
    const remainingValue = remainingSize.multipliedBy(currentPrice);
    const totalCost = soldCost.plus(remainingCost);
    const realizedAbsolutePnl = soldValue.minus(soldCost);
    const unrealizedAbsolutePnl = remainingValue.minus(remainingCost);
    const totalAbsolutePnl = realizedAbsolutePnl.plus(unrealizedAbsolutePnl);
    const totalPercentagePnl = totalCost.isZero()
        ? BigNumber(0)
        : totalAbsolutePnl.dividedBy(totalCost).multipliedBy(100);
    return {
        pnlAbsolute: totalAbsolutePnl,
        pnlPercentage: totalPercentagePnl,
    };
};
export const cmpByAbsolute = Cmp.compareBy((pnl) => pnl.pnlAbsolute, Cmp.cmpBigNumber);
export const cmpByPercentage = Cmp.compareBy((pnl) => pnl.pnlPercentage, Cmp.cmpBigNumber);
//# sourceMappingURL=pnl.js.map